export default {
  'common.captcha':'验证码',
  'common.second':'秒',
  'common.field.sequence': '序号',
  'common.field.operation': '操作',

  "common.button.search":"查询",
  "common.button.reset":"重置",
  "common.button.collapse":"折叠",
  "common.button.OK":"确定",
  "common.button.cancel":"取消",
  "common.button.done":"完成",
  "common.button.browse":"浏览",
  "common.button.view":"查看",
  "common.button.modify":"修改",
  "common.button.delete":"删除",
  "common.button.batchDelete":"批量删除",
  "common.button.import":"导入",
  "common.button.more":"更多",
  "common.button.export":"导出",
  "common.button.logShow":"日志查询",
  "common.button.refresh":"刷新",
  "common.button.save":"保存",
  "common.button.add":"新增",
  "common.button.detail":"详情",
  "common.button.journl":"日志",

  "common.button.enable":"启用",
  "common.button.disconnected":"停用",
"common.systemtitle":"仁建物流管理系统",

  "common.message.Tip":"提示",
  "common.message.error":"错误",
  "common.message.warm_hint":"温馨提示",
  "common.message.delete.confirm": "确定要删除吗？",
  "common.message.operate.success": "操作成功！",
  "common.message.operate.failed": "操作失败！",
  "common.message.unknown.error":"未知错误，请联系管理员",
  "common.message.choose.exportColum":'请选择导出列',
  "common.message.choose.please":"请选择",
  "common.message.request.fail":"请求失败",

  'error':'错误',
  'success':'成功',
  'common.message.delete.success':'删除成功',
  'common.message.delete.failed':'删除失败',


  'common.title.SerialNumber': '序号',
  'common.title.Operation': '操作',
  'common.title.memo': '备注',

};
